import { render, staticRenderFns } from "./Istatistics.vue?vue&type=template&id=436c748f&"
import script from "./Istatistics.vue?vue&type=script&lang=js&"
export * from "./Istatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports